/**
 * @generated SignedSource<<fa88828db931f00170e974b07f163bc1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RetellingStatus = "FAILED" | "PENDING" | "READY" | "%future added value";
export type SessionStatus = "ACTIVE" | "DEBRIEFED" | "DEBRIEFING" | "ENDED" | "FAILED" | "%future added value";
export type ProgressConversationsQuery$variables = {
  language: string;
};
export type ProgressConversationsQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
      readonly id: string;
      readonly retellings: ReadonlyArray<{
        readonly book: {
          readonly cover: string;
          readonly id: string;
          readonly title: string;
        } | null | undefined;
        readonly createdAt: any;
        readonly firstPage: number;
        readonly id: string;
        readonly lastPage: number;
        readonly status: RetellingStatus;
      }>;
      readonly sessions: {
        readonly nodes: ReadonlyArray<{
          readonly character: {
            readonly displayName: string;
          } | null | undefined;
          readonly id: string;
          readonly startedAt: any;
          readonly status: SessionStatus;
          readonly topic: string | null | undefined;
        }>;
      };
      readonly storyReads: ReadonlyArray<{
        readonly book: {
          readonly cover: string;
          readonly gloss: string | null | undefined;
          readonly id: string;
          readonly title: string;
        };
        readonly finishedAt: any;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type ProgressConversationsQuery = {
  response: ProgressConversationsQuery$data;
  variables: ProgressConversationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v4 = [
  (v3/*:: as any*/),
  {
    "kind": "Literal",
    "name": "spoken",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "topic",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cover",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    (v3/*:: as any*/)
  ],
  "concreteType": "Retelling",
  "kind": "LinkedField",
  "name": "retellings",
  "plural": true,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryBook",
      "kind": "LinkedField",
      "name": "book",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        (v9/*:: as any*/),
        (v10/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "retellings(first:20)"
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "StoryRead",
  "kind": "LinkedField",
  "name": "storyReads",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryBook",
      "kind": "LinkedField",
      "name": "book",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        (v9/*:: as any*/),
        (v10/*:: as any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "language",
              "variableName": "language"
            }
          ],
          "kind": "ScalarField",
          "name": "gloss",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProgressConversationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*:: as any*/),
                "concreteType": "SessionConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Session",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v1/*:: as any*/),
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Character",
                        "kind": "LinkedField",
                        "name": "character",
                        "plural": false,
                        "selections": [
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sessions(first:20,spoken:true)"
              },
              (v11/*:: as any*/),
              (v12/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ProgressConversationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*:: as any*/),
                "concreteType": "SessionConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Session",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v1/*:: as any*/),
                      (v5/*:: as any*/),
                      (v6/*:: as any*/),
                      (v7/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Character",
                        "kind": "LinkedField",
                        "name": "character",
                        "plural": false,
                        "selections": [
                          (v8/*:: as any*/),
                          (v1/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sessions(first:20,spoken:true)"
              },
              (v11/*:: as any*/),
              (v12/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cdb4891c6e66d903baa089d1ba3abadd",
    "id": null,
    "metadata": {},
    "name": "ProgressConversationsQuery",
    "operationKind": "query",
    "text": "query ProgressConversationsQuery(\n  $language: String!\n) {\n  me {\n    learner {\n      id\n      defaultCharacter {\n        audience\n        id\n      }\n      sessions(first: 20, spoken: true) {\n        nodes {\n          id\n          topic\n          status\n          startedAt\n          character {\n            displayName\n            id\n          }\n        }\n      }\n      retellings(first: 20) {\n        id\n        firstPage\n        lastPage\n        createdAt\n        status\n        book {\n          id\n          title\n          cover\n        }\n      }\n      storyReads {\n        finishedAt\n        book {\n          id\n          title\n          cover\n          gloss(language: $language)\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f03cf4282c87b10354e132b552982d23";

export default node;
